// extracted by mini-css-extract-plugin
export default {"CMSContainer":"WholeAppLayout_CMSContainer__OU07H"};